import { BlockGroup } from './BlockGroup'
import classes from './SummaryControl.module.scss'
import type { OutputRenderType } from './types'

export const SummaryControl = ({
  renderOutput,
  id
}: {
  renderOutput: OutputRenderType[]
  id: string
}) => {
  return (
    <div className={classes.container}>
      {renderOutput.map((item, index) => {
        return (
          <BlockGroup
            blockDisplayName={item.blockDisplayName}
            blockRenderData={item.blockRenderData}
            id={id}
            key={`${item.blockDisplayName}-${index}`}
            source={item.source}
          />
        )
      })}
    </div>
  )
}
